import { render } from "./budgets.vue?vue&type=template&id=abc51eb8"
import script from "./budgets.vue?vue&type=script&lang=js"
export * from "./budgets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__